import { horizontalGap, Icon, Popover, PopoverRoot, PopoverTrigger, tk, Typography } from '@sunwebgroup/ui-components';
import { HomepageProductAdsList, SearchPageProductAdsList } from './ProductAdsList';
import { styled } from 'styled-components';
import * as React from 'react';

interface ProductAdsProps {
  contextItemId: string;
  headerTitle: string | null;
  infoLabel: string | null;
  infoContent: string | null;
  noFading?: boolean;
  className?: string;
}

const Wrapper = styled.div`
  position: relative;
  padding: ${tk('spacing_lg')} ${tk('spacing_md')};
  display: flex;
  flex-direction: column;
  margin-bottom: ${tk('spacing_3xl')};

  @media ${tk('mq_desktop_sm')} {
    padding: ${tk('spacing_3xl')};
  }
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${tk('theme_color_neutral_300')};
  border-radius: ${tk('radius_extra_large')};
  z-index: -1;

  @media ${tk('mq_desktop_sm')} {
    width: 65%;
  }
`;

const InfoButton = styled.button`
  margin-bottom: ${tk('spacing_xs')};
  color: ${tk('color_semantic_text_strong')};
  width: fit-content;
`;

const Heading = styled(Typography)`
  margin-bottom: ${tk('spacing_md')};

  @media ${tk('mq_desktop_sm')} {
    margin-bottom: ${tk('spacing_xl')};
  }
`;

const InfoButtonContent = styled.div`
  display: flex;
  align-items: center;

  ${horizontalGap('spacing_xs')}
`;

export function ProductAdsComponent({
  contextItemId,
  headerTitle,
  infoContent,
  infoLabel,
  noFading,
  isSearch = false,
}: {
  infoLabel: string | null;
  infoContent: string | null;
  headerTitle: string | null;
  contextItemId: string;
  noFading?: boolean;
  isSearch?: boolean;
}) {
  return (
    <>
      <PopoverRoot>
        {infoLabel && infoContent && (
          <PopoverTrigger asChild>
            <InfoButton>
              <InfoButtonContent>
                <Typography $variant="body-sm">{infoLabel}</Typography>
                <Icon glyph="IconInformationCircle" size="sm" />
              </InfoButtonContent>
            </InfoButton>
          </PopoverTrigger>
        )}
        {headerTitle && (
          <Heading $variant="heading-md" as="h2">
            {headerTitle}
          </Heading>
        )}
        {isSearch ? (
          <SearchPageProductAdsList contextItemId={contextItemId} noFading={noFading} />
        ) : (
          <HomepageProductAdsList contextItemId={contextItemId} noFading={noFading} />
        )}
        <Popover title={infoLabel ?? ''} content={infoContent ?? ''} align="start" avoidCollisions={false} side="top" />
      </PopoverRoot>
    </>
  );
}

export function ProductAds({
  contextItemId,
  headerTitle,
  infoLabel,
  infoContent,
  noFading = false,
  className,
}: ProductAdsProps) {
  return (
    <Wrapper className={className} data-qa="product-ads">
      <Background />
      <ProductAdsComponent
        infoLabel={infoLabel}
        infoContent={infoContent}
        headerTitle={headerTitle}
        contextItemId={contextItemId}
        noFading={noFading}
      />
    </Wrapper>
  );
}
